import { ListOptionsFormController } from '@shared/list-options/list-options-form.controller';

import { CHARGE_POINT_LIST_COLUMN_LABEL_I18N_KEY } from '../charge-point-list/charge-point-list.config';
import { useChargePointListContext } from '../charge-point.context';

export const ChargePointListOptionsController = (): React.JSX.Element => {
  const { columnOptions, setColumnOptions } = useChargePointListContext();

  return (
    <ListOptionsFormController
      columnOptions={columnOptions}
      columnLabelMap={CHARGE_POINT_LIST_COLUMN_LABEL_I18N_KEY}
      onChange={setColumnOptions}
    />
  );
};
